import { IDetailFetcher } from '../fetchers/IDetailFetcher';
import { IListFetcher } from '../fetchers/IListFetcher';
import { ServerDetailFetcher } from '../fetchers/ServerDetailFetcher';
import { ServerResourceFetcher } from '../fetchers/ServerResourceFetcher';
import { Module } from '../Module';
import { IPagedItemsParams } from '../ServerApi/types/IPage';
import { IRequest } from '../ServerApi/types/IRequest';
import { ServerService } from './ServerService';

/**
 * @deprecated Use `WebClientDetailFetcher` or `WebClientListResourceFetcher` instead
 */
export class FetcherFactory {

  public static $inject = [
    '$q',
    'ServerService'
  ];

  constructor(
    private $q: ng.IQService,
    private server: ServerService
  ){}

  public getServerDetailFetcher<TRequestResult, TResource>(
    requestMethod: string,
    resultMapper: (result: TRequestResult) => TResource
  ): IDetailFetcher<TResource> {
    return new ServerDetailFetcher(this.server, this.$q, requestMethod, resultMapper);
  }

  public getServerResourceFetcher<TRequestResult, TResource>(
    requestType: new (params: IPagedItemsParams) => IRequest<IPagedItemsParams, TRequestResult>,
    resultMapper: (result: TRequestResult) => TResource[]
  ): IListFetcher<TResource> {
    return new ServerResourceFetcher(this.server, requestType, resultMapper);
  }

}

Module.instance().service('FetcherFactory', FetcherFactory);
